import axios from "axios";
import {
  REDIRECT_DELAY_MS,
  REAUTH_MESSAGES,
  ReauthService,
} from "./ReauthService";

const CURRENT_TAB_KEY = "reauth:currentTab";
const REDIRECT_SAFETY_MARGIN_MS = 500;

export function setCurrentTabForReauth(tab: string) {
  sessionStorage.setItem(CURRENT_TAB_KEY, tab);
}

function getCurrentTabForReauth(): string {
  return sessionStorage.getItem(CURRENT_TAB_KEY) || "tab1";
}

let reauthInFlight = false;

export function resetReauthInFlight() {
  reauthInFlight = false;
}

export function registerReauthInterceptor() {
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status;
      const code = error?.response?.data?.error;

      if (
        status === 401 &&
        (code === "REAUTH_REQUIRED" || code === "LOGIN_REQUIRED") &&
        !reauthInFlight
      ) {
        reauthInFlight = true;
        let safetyTimeoutId: ReturnType<typeof setTimeout> | undefined;

        const clearSafetyTimeout = () => {
          if (safetyTimeoutId !== undefined) {
            clearTimeout(safetyTimeoutId);
            safetyTimeoutId = undefined;
          }
        };

        const releaseReauthLock = () => {
          clearSafetyTimeout();
          resetReauthInFlight();
        };

        try {
          safetyTimeoutId = setTimeout(
            releaseReauthLock,
            REDIRECT_DELAY_MS + REDIRECT_SAFETY_MARGIN_MS
          );

          await ReauthService.triggerReauth(
            {
              action: "retry",
              tab: getCurrentTabForReauth(),
            },
            REAUTH_MESSAGES[code as keyof typeof REAUTH_MESSAGES],
            releaseReauthLock
          );
        } catch {
          releaseReauthLock();
        }
      }

      return Promise.reject(error);
    }
  );
}
